import { Reveal } from "@/components/Motion";

const STATS = [
  { value: "2017", label: "Teaching since", id: "since" },
  { value: "5.0", label: "Google rating", id: "reviews" },
  { value: "03", label: "Languages taught", id: "languages" },
  { value: "≤10", label: "Learners per batch", id: "batch" },
];

export default function StatsStrip() {
  return (
    <section className="border-b border-white/10" data-testid="stats-strip">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.08} className={`py-12 lg:py-16 px-4 lg:px-10 ${i > 0 ? "border-l border-white/10" : ""} ${i > 1 ? "border-t lg:border-t-0 border-white/10" : ""}`}>
            <p className="font-display text-4xl lg:text-6xl tracking-tighter text-[#F4F4F0]" data-testid={`stat-value-${s.id}`}>
              {s.value}
            </p>
            <p className="mt-3 text-[10px] lg:text-xs uppercase tracking-[0.25em] text-[#A3A3A3]">{s.label}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
